import React from "react";
import config from "lib/fr-config";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TXT from "presentational/common/multinational/TXT";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;
const colorCss = config.css.color;

const containerStyle = {
  desktop: { marginBottom: 70, display: "flex", justifyContent: "center" },
  mobile: { marginBottom: 50, display: "flex", justifyContent: "center" }
};

const StyledTable = withStyles({
  root: {
    maxWidth: 640,
    borderCollapse: "separate"
  }
})(Table);

const HeadCell = withStyles({
  root: {
    fontSize: 16,
    fontWeight: fontCss.bold,
    borderBottom: "2px solid #e0e0e0"
  }
})(TableCell);

const BodyCell = withStyles({
  root: {
    padding: "10px 8px",
    borderBottom: "1px solid #eee",
    verticalAlign: "top"
  }
})(TableCell);

const FeatureCell = withStyles({
  root: {
    fontWeight: fontCss.bold,
    width: "40%"
  }
})(BodyCell);

const PriceText = withStyles({
  root: {
    fontSize: getDeviceType() === "desktop" ? 14 : 12,
    lineHeight: 1.5
  }
})(Typography);

const Highlight = withStyles({
  root: {
    fontSize: getDeviceType() === "desktop" ? 14 : 12,
    color: colorCss.colorOfPrimary,
    fontWeight: fontCss.bold
  }
})(Typography);

SubscribeInfoSectionView.propTypes = {
  priceInfo: PropTypes.shape({
    originalPrice: PropTypes.object.isRequired,
    discountedPrice: PropTypes.object,
    paypalPlanId: PropTypes.string,
    saleEndDate: PropTypes.string,
    validUntil: PropTypes.string.isRequired
  }).isRequired
};

function SubscribeInfoSectionView({ priceInfo }) {
  const device = getDeviceType() === "desktop" ? "desktop" : "mobile";

  const onSale = !!priceInfo.discountedPrice;

  const originalUSD = priceInfo.originalPrice.us_dollar;
  const originalKRW = priceInfo.originalPrice.kr_won;
  const discountUSD = onSale && priceInfo.discountedPrice.us_dollar;
  const discountKRW = onSale && priceInfo.discountedPrice.kr_won;

  const formatKRW = v => new Intl.NumberFormat("ko-KR").format(v);

  const PriceBlock = ({ usd, krw, strike }) => (
    <PriceText
      style={strike ? { textDecoration: "line-through", opacity: 0.6 } : {}}
    >
      <TXT
        name="wordMembershipPrice"
        input={{ us_dollar: usd, kr_won: formatKRW(krw) }}
      />
      <TXT name="wordMembershipBillingPeriod" />
    </PriceText>
  );

  return (
    <div style={containerStyle[device]}>
      <StyledTable>
        <TableHead>
          <TableRow>
            <HeadCell />
            <HeadCell align="right">
              <TXT name="membTableElem_outfitJournalPlan" />
            </HeadCell>
            <HeadCell align="right">
              <TXT name="membTableElem_maunentCreative" />
            </HeadCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {/* 가격 */}
          <TableRow hover>
            <FeatureCell />
            <BodyCell align="right">
              <PriceBlock usd={0} krw={0} />
            </BodyCell>
            <BodyCell align="right">
              {onSale && (
                <PriceBlock usd={originalUSD} krw={originalKRW} strike />
              )}
              <PriceBlock
                usd={onSale ? discountUSD : originalUSD}
                krw={onSale ? discountKRW : originalKRW}
              />
            </BodyCell>
          </TableRow>

          {/* 기능 행 공통 패턴 */}
          {[
            [
              "membTableElem_voteSubmission",
              "membTableElem_voteSubmissionForFree",
              "membTableElem_voteSubmissionForMember",
              "membTableElem_voteSubmissionForMember2"
            ],
            [
              "membTableElem_collectionSaves",
              "membTableElem_collectionSavesForFree",
              "membTableElem_collectionSavesForMember"
            ],
            [
              "membTableElem_collectionFolders",
              "membTableElem_collectionFoldersForFree",
              "membTableElem_collectionFoldersForMember"
            ],
            [
              "membTableElem_favoriteSaves",
              "membTableElem_favoriteSavesForFree",
              "membTableElem_favoriteSavesForMember"
            ],
            [
              "membTableElem_FavoriteFolders",
              "membTableElem_FavoriteFoldersForFree",
              "membTableElem_FavoriteFoldersForMember"
            ],
            [
              "membTableElem_VoteHistoryAccess",
              "membTableElem_VoteHistoryAccessForFree",
              "membTableElem_VoteHistoryAccessForMember"
            ],
            [
              "membTableElem_searchResults",
              "membTableElem_searchResultsForFree",
              "membTableElem_searchResultsForMember"
            ]
          ].map(([title, free, member, highlight]) => (
            <TableRow hover key={title}>
              <FeatureCell>
                <TXT name={title} />
              </FeatureCell>

              <BodyCell align="right">
                <PriceText>
                  <TXT name={free} />
                </PriceText>
              </BodyCell>

              <BodyCell align="right">
                <PriceText>
                  <TXT name={member} />
                </PriceText>
                {highlight && (
                  <Highlight>
                    <TXT name={highlight} />
                  </Highlight>
                )}
              </BodyCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </div>
  );
}

export default SubscribeInfoSectionView;
